import ITabInfo, { Menus } from "./ITabInfo";
import Roles from "./Roles";

const TabInfos: Array<ITabInfo> = [
  {
    label: "Support",
    route: "/support",
    menu: Menus.support,
    includedRoles: [Roles.Support, Roles.Admin],
  },
  {
    label: "Documentation",
    route: "/docs",
    menu: Menus.docs,
    includedRoles: [Roles.Documentation, Roles.Admin],
  },
  {
    label: "Partnership",
    route: "/partnership",
  },
];

export default TabInfos;
